import { Share } from '@capacitor/share';

interface ShareContentProps {
  title: string;
  text?: string;
  url?: string;
  dialogTitle?: string;
}

export const shareContent = async ({
  title,
  text,
  url,
  dialogTitle
}: ShareContentProps) => {
  try {
    await Share.share({
      title,
      text,
      url,
      dialogTitle,
    });
  } catch (error) {
    console.error('Error sharing:', error);
    throw error;
  }
};